import React, { useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import LaunchIcon from '@material-ui/icons/Launch'
import SaveIcon from '@material-ui/icons/Save'
import FileViewer from 'react-file-viewer'
import PreviewImage from 'react-preview-image'
import isImage from 'is-image'
import { withStyles, Button, Link } from '@material-ui/core'

const styles = theme => ({
  btn: {
    marginRight: theme.spacing(1),
    width: '100%'
  },
  centerBtn: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: theme.spacing(1)
  }
})

const indicatorStyle = {
  display: 'none'
}

const CustomFileViewer = ({ classes, label, filePath, newTab }) => {
  const fileType =
    filePath && typeof filePath === 'string'
      ? filePath.split('.').slice(-1)[0]
      : ''
  const [dialog, setDialog] = useState(false)

  return (
    <div hidden={!filePath}>
      {newTab ? (
        <Link href={filePath} target="_blank">
          <Button
            variant="contained"
            color="secondary"
            className={classes.btn}
            startIcon={<LaunchIcon />}
          >
            Abrir {label}
          </Button>
        </Link>
      ) : (
        <Button
          variant="contained"
          color="secondary"
          className={classes.btn}
          startIcon={<LaunchIcon />}
          onClick={() => setDialog(true)}
        >
          Abrir {label}
        </Button>
      )}
      <Dialog fullWidth open={dialog} onClose={() => setDialog(false)}>
        {isImage(filePath) ? (
          <PreviewImage
            source={[filePath]}
            index={0}
            visible={dialog}
            indicatorStyle={indicatorStyle}
            onHide={() => setDialog(false)}
          />
        ) : (
          <div>
            <div className={classes.centerBtn}>
              <Button
                href={filePath}
                target="_blank"
                variant="contained"
                color="primary"
                size="small"
                startIcon={<SaveIcon />}
              >
                Download
              </Button>
            </div>
            <FileViewer
              fileType={fileType}
              filePath={filePath}
              errorComponent={<p>Erro</p>}
              onError={() => null}
            />
          </div>
        )}
      </Dialog>
    </div>
  )
}

export default withStyles(styles)(CustomFileViewer)
